import React from 'react';
import { awsUsersFileURL } from '../../../contexts/utils';

export const StatsListCon = ({ user, ride }) => {
  return (
    <div className='stats-list-body-con'>
      <div className='with-avatar'>
        <div className='avatar'>
          <img
            src={`${awsUsersFileURL}${user ? user.image : ride.passengerImage}`}
            alt={`${user ? user.name : ride.passengerName} img`}
          />
        </div>
        <div className='username'>
          <p>{user ? user.name : ride.passengerName}</p>
        </div>
      </div>
      <p>{user ? user.completedRides : ride.totalRideTime}</p>
      {user ? <p>{user.canceledRides}</p> : <p>&#8358;{ride.paidAmnt}</p>}
      <p>{user ? user.createdAt : ride.date}</p>
    </div>
  );
};
